import moment from "moment";

const START_OF_TIME = moment(0);

function getDayRangeString(range, options = {}, forTooltip = true) {
  const day1 = options.start
    ? moment.max(moment(options.start), range[0])
    : range[0];
  const day2 = options.end
    ? moment.min(moment(options.end), range[range.length - 1])
    : range[range.length - 1];

  if (!day1.isValid() && !day2.isValid()) {
    return `All Time`;
  }

  if (!day1.isValid() || day1.isSameOrBefore(START_OF_TIME)) {
    return `Before ${day2.format("MMMM D, YYYY")}`;
  }

  if (!day2.isValid() || day2.isSameOrBefore(START_OF_TIME)) {
    return `After ${day1.format("MMMM D, YYYY")}`;
  }

  if (day1.year() !== day2.year()) {
    return `${day1.format("MMM D YYYY")} - ${day2.format("MMM D YYYY")}`;
  }

  if (day1.month() !== day2.month()) {
    return forTooltip
      ? `${day1.format("MMM D")} - ${day2.format("MMM D")}, ${day2.format(
          "YYYY"
        )}`
      : `${day1.format("MMM D")} - ${day2.format("MMM D")}`;
  }

  if (day1.day() !== day2.day() || day1.week() !== day2.week()) {
    return forTooltip
      ? `${day1.format("MMMM D")} - ${day2.format("D")}, ${day2.format("YYYY")}`
      : `${day1.format("MMM D")} - ${day2.format("D")}`;
  }

  return forTooltip
    ? `${day1.format("MMMM D, YYYY")}`
    : `${day1.format("MMM D")}`;
}

export default getDayRangeString;
